const allNavParent = document.querySelectorAll('.nav-parent');
const allNavLabelLeft = document.querySelectorAll('.nav-label-leaf');
const allNavChild = document.querySelectorAll('.nav-child');
const drawerSide = document.querySelector('.drawer-side');
const menuButton = document.querySelector('#menu-button');

menuButton.addEventListener('click', (e) => {
  e.stopPropagation()
  drawerSide.parentElement.classList.remove('hidden')
  drawerSide.parentElement.classList.add('flex')
  drawerSide.previousElementSibling.classList.remove('-translate-x-full')
  drawerSide.parentElement.classList.remove('bg-transparent')
})

drawerSide.addEventListener('click', (e) => {
  e.stopPropagation()
  drawerSide.previousElementSibling.classList.add('-translate-x-full')
  drawerSide.parentElement.classList.add('bg-transparent')
  allNavChild.forEach((navChild) => {
    navChild.classList.remove('active')
  })
  setTimeout(() => {
    drawerSide.parentElement.classList.add('hidden')
    drawerSide.parentElement.classList.remove('flex')
  }, 150)
})

allNavLabelLeft.forEach((navLabel) => {
  navLabel.addEventListener('click', (e) => {
    e.stopPropagation()
  })
})

allNavParent.forEach((navParent) => {
  const labelElement = navParent.children[0];
  const navChildElement = navParent.children[1];

  navParent.addEventListener('click', (e) => {
    e.stopPropagation()
    if (navChildElement.classList.contains('active')) {
      navChildElement.classList.remove('active')
      labelElement.querySelector('i').classList.remove('rotate-90')

      const allNavChild = navChildElement.querySelectorAll('.nav-child')
      allNavChild.forEach((navChild) => {
        navChild.classList.remove('active')
      })

      const allNavLabel = navChildElement.querySelectorAll('.nav-label')
      allNavLabel.forEach((navLabel) => {
        navLabel.querySelector('i').classList.remove('rotate-90')
      })

    } else {
      navChildElement.classList.add('active')
      labelElement.querySelector('i').classList.add('rotate-90')
    }
  })
})

//slider
const swiper = new Swiper('.swiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  autoplay: {
    delay: 3000,
  },
  speed: 1000,
});

//language setting
const languageSettingButton = document.querySelector('.language-setting__btn')
const languageSettingModal = document.querySelector('.language-setting__modal')

languageSettingButton.addEventListener('click', (e) => {
  languageSettingModal.classList.toggle('hidden')
})

//category
const dropdownList = document.querySelectorAll('.category .dropdown')

dropdownList.forEach(dropdown => {
  const label = dropdown.querySelector('.dropdown-label')

  label.addEventListener('click', (e) => {
    e.stopPropagation()
    dropdown.classList.toggle('active')
  })
})


const filter = document.querySelector('.category .filter-wrapper')
const filterContent = document.querySelector('.category .filter-content')

filter?.addEventListener('click', (e) => {
  e.stopPropagation()
  filter.classList.remove('active')
})

filterContent?.addEventListener('click', (e) => {
  e.stopPropagation()
})

const filterButton = document.querySelector('.filter-btn')
const closeFilterButton = document.querySelector('.close-filter-button')

filterButton?.addEventListener('click', (e) => {
  e.stopPropagation()
  filter.classList.add('active')
})

closeFilterButton?.addEventListener('click', (e) => {
  e.stopPropagation()
  filter.classList.remove('active')
})

const itemColors = document.getElementsByClassName('item-color');

function fetchJSONData() {
  fetch('https://printdropexpress.com/cdn/shop/t/1/assets/colors.json')
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
      if (itemColors.length) {
        for (let i = 0; i < itemColors.length; i++) {
          const element = itemColors[i];
          const colorItem = data.find(
            (item) => item.color === element.dataset.value
          );
          element.style.backgroundColor = colorItem.code;
        };
      }
    })
    .catch((error) => console.error('Unable to fetch data:', error));
}
fetchJSONData();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.replace-newline').forEach((element) => {
    element.innerHTML = element.textContent.replace(/\\n/g, '\n');
  });

  // add to cart for product snippet
  const btnAddToCartSnippets = document.querySelectorAll('.snippet-add-cart');
  btnAddToCartSnippets.forEach((element) => {
    const customerId = element.dataset.customer;
    const productHandle = element.dataset.productHandle;
    const productId = element.dataset.productId;
    const designUrl = element.dataset.designUrl;
    const variantId = element.dataset.variantId;
    element.addEventListener('click', async function (event) {
      event.preventDefault();
      const productDetail = await getDetailProduct(productId);
      if (!productDetail) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Product not available!",
          showConfirmButton: false,
          timer: 1500
        });
        return;
      }
      if (productDetail.is_supplier_product) {
        const myUrlWithParams = new URL(
          `${productHandle}/${productId}/${customerId}`,
          designUrl
        );
        myUrlWithParams.searchParams.append('return_url', location.href);
        myUrlWithParams.searchParams.append('shop_id', productDetail.shop_id);
        myUrlWithParams.searchParams.append('variantId', variantId);
        window.open(myUrlWithParams.href, '_blank');
      } else {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append("quantity", 1);
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          const data = await response.json();
          window.location.href = '/cart';
        } catch (error) {
          console.error('Error adding product to cart:', error);
        }
      }
    });
  });

  async function getDetailProduct(productId) {
    const productData = await fetchAPI(`product/shopify/${productId}`);
    if (!productData.success) return null;

    const { shop_id, is_supplier_product } = productData.data;
    return { shop_id, is_supplier_product };
  }

  const logoutLinks = document.querySelectorAll('a[href*="/account/logout"]');
  /*
  logoutLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
      }).then(function () {
          window.location.href = link.href;
      });
    });
  });
  */
})

